import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { Spin } from "antd";

const ProtectedRoute = ({ requiredRole }) => {
    const { isAuthenticated, user, setReferer, hasRole, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) {
        return <Spin />;
    }

    if (!isAuthenticated) {
        /* Kirjautumissivulle, ei etusivulle (Mika 30.9.2026): tekstiviestin linkki
           kauppakirjaan avautuu puhelimessa ilman kirjautumista, ja etusivulle tiputettu
           asiakas ei tiedä mitä tehdä. Login.js vie location.state.from -osoitteeseen
           heti kirjautumisen jälkeen. */
        setReferer(location.pathname + location.search);
        return <Navigate to="/kirjaudu" state={{ from: location.pathname + location.search }} replace />;
    }

    if (requiredRole && (!user || !hasRole(user.roles, requiredRole))) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
